import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import { ReportTableComponent } from '../report-table/report-table.component';
import { REPORTING_EVENTS } from './../../services/reporting.service';

interface ILogData {
  userId: string;
  logDateTime: string;
  ipAddress: string;
  messages: string;
}

@Component({
  selector: 'ab-sign-in-log-table',
  templateUrl: './sign-in-log-table.component.html',
  styleUrls: ['./sign-in-log-table.component.scss']
})
export class SignInLogTableComponent extends ReportTableComponent
  implements OnInit {
  @Input() rendering: ComponentRendering;
  declare public items: Array<ILogData>;
  public totalRecordLabel: string;

  ngOnInit() {
    this.subscribe(REPORTING_EVENTS.SIGN_IN);
    this.columns = (this.rendering.fields.items as Array<any>).map(column => {
      return column.fields.label.value;
    });
    this.totalRecordLabel = this.columns.pop();
  }
}
